import { config } from "../config/config";

function retrieveCookie(name) {
    const value = '; ' + document.cookie;
    const parts = value.split(`; ${name}=`);

    if (parts.length === 2) {
        return parts.pop().split(';').shift();
    }
    return "";
}

function setAuthCookie(value) {
    const expires = "";
    document.cookie = `${config.authentication.authenticationCookie}=Bearer_${value}; domain=.gm.com; path=/; expires=${expires}`;
}

function deleteAuthCookie() {
    document.cookie = config.authentication.authenticationCookie + '=; domain=.gm.com; path=/; expires=-1';
}

export const cgpCookieHelper = {
    retrieveCookie,
    setAuthCookie,
    deleteAuthCookie
}
